export default "__VITE_ASSET__BExLybBm__"